import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Container } from 'react-bootstrap';
import Button from './Button';

function ButtonDemo({ children }: any) {
  return (
    <Container>
      <Container className="mt-10">
        <h4>Primary Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="primary">Proceed</Button>
          <Button variant="primary" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary" size="sm">
            Proceed
          </Button>
          <Button variant="primary" leftIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
          <Button variant="primary" rightIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Primary Outline Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="primary-outline">Proceed</Button>
          <Button variant="primary-outline" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary-outline" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary-outline" size="sm">
            Proceed
          </Button>
          <Button
            variant="primary-outline"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="primary-outline"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Primary Shadow Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="primary-shadow">Proceed</Button>
          <Button variant="primary-shadow" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary-shadow" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="primary-shadow" size="sm">
            Proceed
          </Button>
          <Button
            variant="primary-shadow"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="primary-shadow"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Secondary Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="secondary">Proceed</Button>
          <Button variant="secondary" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary" size="sm">
            Proceed
          </Button>
          <Button variant="secondary" leftIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
          <Button
            variant="secondary"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Secondary Outline Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="secondary-outline">Proceed</Button>
          <Button variant="secondary-outline" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary-outline" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary-outline" size="sm">
            Proceed
          </Button>
          <Button
            variant="secondary-outline"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="secondary-outline"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Secondary Shadow Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="secondary-shadow">Proceed</Button>
          <Button variant="secondary-shadow" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary-shadow" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="secondary-shadow" size="sm">
            Proceed
          </Button>
          <Button
            variant="secondary-shadow"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="secondary-shadow"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Danger Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="danger">Proceed</Button>
          <Button variant="danger" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger" size="sm">
            Proceed
          </Button>
          <Button variant="danger" leftIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
          <Button variant="danger" rightIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Danger Outline Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="danger-outline">Proceed</Button>
          <Button variant="danger-outline" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger-outline" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger-outline" size="sm">
            Proceed
          </Button>
          <Button
            variant="danger-outline"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="danger-outline"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Danger Shadow Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="danger-shadow">Proceed</Button>
          <Button variant="danger-shadow" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger-shadow" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="danger-shadow" size="sm">
            Proceed
          </Button>
          <Button
            variant="danger-shadow"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="danger-shadow"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container
        className="mt-10"
        style={{ backgroundColor: '#f93b1d', padding: '10px' }}
      >
        <h4>Danger Transparent White Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="danger-transparent-white">Proceed</Button>
          <Button
            variant="danger-transparent-white"
            leftIcon={light('house-blank')}
          >
            Proceed
          </Button>
          <Button
            variant="danger-transparent-white"
            rightIcon={light('house-blank')}
          >
            Proceed
          </Button>
          <Button variant="danger-transparent-white" size="sm">
            Proceed
          </Button>
          <Button
            variant="danger-transparent-white"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="danger-transparent-white"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Success Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="success">Proceed</Button>
          <Button variant="success" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success" size="sm">
            Proceed
          </Button>
          <Button variant="success" leftIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
          <Button variant="success" rightIcon={light('house-blank')} size="sm">
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Success Outline Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="success-outline">Proceed</Button>
          <Button variant="success-outline" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success-outline" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success-outline" size="sm">
            Proceed
          </Button>
          <Button
            variant="success-outline"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="success-outline"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Success Shadow Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="success-shadow">Proceed</Button>
          <Button variant="success-shadow" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success-shadow" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="success-shadow" size="sm">
            Proceed
          </Button>
          <Button
            variant="success-shadow"
            leftIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
          <Button
            variant="success-shadow"
            rightIcon={light('house-blank')}
            size="sm"
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Disabled Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="primary" disabled>
            Proceed
          </Button>
          <Button variant="primary" leftIcon={light('house-blank')} disabled>
            Proceed
          </Button>
          <Button variant="primary-outline" disabled>
            Proceed
          </Button>
          <Button
            variant="primary-outline"
            rightIcon={light('house-blank')}
            disabled
          >
            Proceed
          </Button>
          <Button variant="primary-shadow" disabled>
            Proceed
          </Button>
          <Button
            variant="primary-shadow"
            leftIcon={light('house-blank')}
            disabled
          >
            Proceed
          </Button>
        </Container>
      </Container>
      <Container className="mt-10">
        <h4>Transperant Buttons</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center">
          <Button variant="transperant">Proceed</Button>
          <Button variant="transperant" leftIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="transperant">Proceed</Button>
          <Button variant="transperant" rightIcon={light('house-blank')}>
            Proceed
          </Button>
          <Button variant="transperant">Proceed</Button>
          <Button variant="transperant" leftIcon={light('house-blank')}>
            Proceed
          </Button>
        </Container>
      </Container>
    </Container>
  );
}

export default ButtonDemo;
